import * as React from 'react';
import TextField from '@mui/material/TextField';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ButtonBase, IconButton, InputAdornment, MenuItem } from '@mui/material';
import { KeyedObject } from 'types';

const InputField = (props: KeyedObject) => {
    const { label, sx, type = 'text', onChange, select, selectvalues, value, start, states, readOnly, rootstyles = 'white', link } = props;
    const [showPassword, setShowPassword] = React.useState(false);

    const handleTogglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const numeric = start ? { inputMode: 'numeric', pattern: '[0-9]*' } : {};
    const readonly = { readOnly: readOnly ? true : false };

    const renderEndAdornment = () => {
        if (type === 'password') {
            return (
                <InputAdornment position="end">
                    <IconButton aria-label="toggle password visibility" onClick={handleTogglePasswordVisibility} edge="end">
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                </InputAdornment>
            );
        }
        if (type === 'change') {
            return (
                <ButtonBase
                    style={{
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        position: 'absolute',
                        bottom: '12px',
                        right: '22px',
                        color: '#111',
                        fontSize: '14px',
                        fontWeight: '600'
                    }}
                    onClick={link}
                >
                    change
                </ButtonBase>
            );
        }

        return null;
    };
    return (
        <TextField
            {...props}
            select={select}
            value={value}
            autoComplete="off"
            inputMode={start ? 'numeric' : 'text'}
            label={label}
            onChange={onChange}
            variant="filled"
            InputLabelProps={{}}
            InputProps={
                {
                    ...readonly,
                    ...numeric,
                    disableUnderline: true,
                    startAdornment: start && <InputAdornment position="start">$</InputAdornment>,
                    endAdornment: renderEndAdornment()
                } as KeyedObject
            }
            type={showPassword ? 'text' : type ?? 'text'}
            fullWidth
            sx={{
                outline: 'none',
                fontSize: '16px',
                '& .Mui-focused': {
                    outline: 'none',
                    boxShadow: 'none',
                    color: 'grey'
                },
                '& .MuiFilledInput-root': {
                    background: 'white',
                    border: '1px solid #DCDCDC',
                    borderRadius: '12px',
                    ...rootstyles
                },
                '& .MuiFilledInput-root.Mui-focused': {
                    borderColor: '#002443'
                },
                ...sx
            }}
        >
            {selectvalues &&
                selectvalues.map((option: string, index: number) => (
                    <MenuItem key={option} value={option}>
                        {option === '' ? 'None' : option}
                    </MenuItem>
                ))}
            {states &&
                states.map((obj: KeyedObject, index: number) => (
                    <MenuItem key={obj.value} value={obj.value}>
                        {obj.option}
                    </MenuItem>
                ))}
        </TextField>
    );
};

export default InputField;
